import { useAuth } from '@clerk/clerk-react'
import { useQuery } from '@tanstack/react-query'

import { authFetch } from '@/lib/api'

/**
 * Tiny pulsing green dot anchored to the brand glyph (top-left). Green
 * when `/api/eric/health` reports online, grey + a "last seen" tooltip
 * when not. Polls every 30s.
 */
export function EricOnlineDot() {
  const { getToken, isLoaded } = useAuth()
  const { data, isError } = useQuery({
    queryKey: ['eric-health'],
    enabled: isLoaded,
    queryFn: () =>
      authFetch<{ online: boolean; last_seen_ms_ago: number; checked_at: string }>(
        '/api/eric/health',
        getToken,
      ),
    refetchInterval: 30_000,
    staleTime: 25_000,
  })

  const online = !isError && data?.online !== false

  return (
    <span
      aria-label={online ? 'Eric is online' : 'Eric is offline'}
      title={online ? 'Eric is online' : 'Eric is offline'}
      className="relative ml-2 inline-flex h-2 w-2 shrink-0"
    >
      <span
        className={
          online
            ? 'absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-75 motion-reduce:animate-none'
            : 'hidden'
        }
      />
      <span
        className={
          'relative inline-flex h-2 w-2 rounded-full ' +
          (online ? 'bg-emerald-500' : 'bg-slate-300')
        }
      />
    </span>
  )
}
